module.exports = __webpack_public_path__ + "img/source04_2.b73b6a2b.png";